import React, { useState, useRef, useEffect } from "react";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import { useLocation, useNavigate } from "react-router-dom";
import * as TRFListRegistrationService from "../../Services/B2BRegistration/TRFListRegistrationService";
import toast, { Toaster } from "react-hot-toast";
import * as moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaInfoCircle, FaSearch, FaSpinner, FaEye, FaPaperPlane, FaSyncAlt, FaCheckCircle, FaToggleOn, FaToggleOff, FaPen, FaTrash, FaTimesCircle, FaUser, FaFileAlt, FaClipboardList, FaPlus } from "react-icons/fa";
import { Calendar, Eye } from "lucide-react";
import * as CommonVariables from '../../Common/CommonVariables'
import Popover from '../../Common/Popper';
import * as B2BRegistrationService from "../../Services/B2BRegistration/B2BRegistrationService";
import * as PartnerService from "../../Services/Partner/PartnerService";
import CommonPagination from "../../Common/CommonPagination";
import { format, parseISO } from "date-fns";
import PatientTestDetailsModalComponent from "../PatientVisit/PatientTestDetailsModalComponent";
import { store } from "../../Store/store";
import { useSelector } from "react-redux";
import { trackPromise } from "react-promise-tracker";
import axios from "axios";
import "./TRFRegistrationListComponent.css"
import Swal from "sweetalert2";


const TRFRegistrationListComponent = () => {
    const navigate = useNavigate();

    const userInfo = store.getState();
    const userDetails = userInfo?.userData;

    const [filteredB2BTRFRegistrationtList, setFilteredB2BTRFRegistrationtList] = useState([]);
    const [b2bTRFRegistrationDetails, setB2BTRFRegistrationDetails] = useState([]);
    const [selectedTest, setSelectedTest] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [showAttachments, setShowAttachments] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [SearchLoading, setSearchLoading] = useState(false);
    const [dateRangeOption, setDateRangeOption] = useState('Today');
    const [showPatientTestDetails, setShowPatientTestDetails] = useState(false);
    const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
    const [patient, setPatient] = useState({});
    const [visit, setVisit] = useState({});
    const [samples, setSamples] = useState([]);
    const [tests, setTests] = useState([]);
    const [reportURL, setReportURL] = useState("");
    const [reportWOSURL, setReportWOSURL] = useState("");
    const [visitStatus, setVisitStatus] = useState("");
    const [crmVisitDetails, setCRMVisitDetails] = useState([]);
    const [showPatientTestTATModal, setshowPatientTestTATModal] = useState(false);
    const [trflist, setTrflist] = useState([]);

    const orgId = useSelector((state) => state.selectedOrganization);
    const clientCode = useSelector((state) => state.Partner_Account_Details?.MHL_Client_Code__c);

    const accountDetails = useSelector((state) => state.Partner_Account_Details);

    const selectedSearchPR = useRef()

    const location = useLocation();
    const [initDone, setInitDone] = useState(false);


    const GetPatientTestDetailTAT = (data) => {

        setSearchLoading(true);
        setCRMVisitDetails(data);
        PartnerService.GetPatientTestsDetailsByVID(data.Vid, orgId.MHL_Org_Id__c)
            .then(({ data }) => {
                //debugger;
                //console.log("PatientTest API response:", data);
                if (data.IsSuccess) {
                    setshowPatientTestTATModal(true);
                    const response = data.Data;

                    setPatient(response.PatientDemographics || {});
                    setVisit(response.PatientVisitDetails || {});
                    setSamples(response.SampleInfoList || []);
                    setTests(response.TestOrderDetails || []);
                    setReportURL(response.ReportS3URL || "");
                    setReportWOSURL(response.ReportWOSS3URL || "");
                    setVisitStatus(response.VisitStatus || "");

                    // setPatientReportList(data.Data);
                }
                else {
                    // setPatientReportList([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
        // setTestDetailsbyVID(data.MHL_Test_Details_List);
    }

    useEffect(() => {
        if (orgId) {
            fetchB2BTRFRegistrationListData();
            setSelectedTRFPDFArrayList([]);
        }
    }, [orgId]);


    useEffect(() => {
        if (!initDone && location.state) {
            const { startDate: passedStartDate, endDate: passedEndDate, dateRangeOption: passedOption } = location.state;

            if (passedStartDate && endDate) {
                setDateRangeOption(passedOption || 'Custom');
                setStartDate(new Date(passedStartDate));
                setEndDate(new Date(passedEndDate));
                setInitDone(true); // Prevents re-running this logic
            }
        }
    }, [location.state, initDone]);

    useEffect(() => {
        if (initDone && startDate && endDate) {
            fetchB2BTRFRegistrationListData();
        }
    }, [initDone, startDate, endDate, dateRangeOption]);


    useEffect(() => {
        if (startDate && endDate) {
            fetchB2BTRFRegistrationListData();
        }
    }, [dateRangeOption]);

    const validateDateRange = (startDateValue, endDateValue) => {
        if (!startDateValue || !endDateValue) {
            toast.error("Please select a date range");
            return false;
        }
        if (startDateValue > endDateValue) {
            toast.error("Start date cannot be after end date");
            return false;
        }
        if (endDateValue > new Date()) {
            toast.error("End date cannot be in the future");
            return false;
        }
        return true;
    };

    const handleReportDownload = async (reportURL) => {

        const requestUrl = `${CommonVariables.API_DOMAIN}Account/Download?url=${encodeURIComponent(reportURL)}`;

        try {
            const response = await trackPromise(
                axios.get(requestUrl, CommonVariables.API_HEADER)
            );

            const fileUrl = response.data.Data; // assuming the API returns a direct URL to open
            if (fileUrl) {
                window.open(fileUrl, '_blank');
            } else {
                toast.error('File URL is empty.');
            }

        } catch (error) {
            console.error('Download failed:', error);
            toast.error('Download failed.');
        }
    };

    const formatDate = (date, isEnd = false) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        if (isEnd) {
            return `${year}-${month}-${day}T23:59:59`;
        }
        return `${year}-${month}-${day}T00:00:00`;
    };

    const fetchB2BTRFRegistrationListData = () => {
        setFilteredB2BTRFRegistrationtList([]);
        // if (!validateDateRange(startDate, endDate)) return;

        if (dateRangeOption === "Custom") {
            if (!startDate || !endDate) {
                toast.error("Please select both Start Date and End Date for Custom range");
                return;
            }
        }

        setSearchLoading(true);
        setLoading(true);
        //debugger;

        const payload = {
            ClientCode: clientCode,
            OrgId: parseInt(orgId?.MHL_Org_Id__c),
            StartDate: formatDate(startDate),
            EndDate: formatDate(endDate, true)
        }

        TRFListRegistrationService.GetB2BTRFRegistrationListData(payload)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //console.log(data.Data);
                    setFilteredB2BTRFRegistrationtList(data.Data);
                } else {
                    setFilteredB2BTRFRegistrationtList([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setLoading(false);
                setSearchLoading(false);
            });
    };

    const fetchUniversalFilterTRFListData = () => {
        if (!orgId) {
            setFilteredB2BTRFRegistrationtList([])
            return;
        }

        if (selectedSearchPR.current.value == null || selectedSearchPR.current.value == "") {
            // window.location.reload();
            toast.error("Please enter search data.")
            return;
        }
        // setLoading(true);
        setSearchLoading(true);
        TRFListRegistrationService.GetUniversalB2BTRFRegistrationDataList(selectedSearchPR.current.value, clientCode)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setFilteredB2BTRFRegistrationtList(data.Data);
                }
                else {
                    setFilteredB2BTRFRegistrationtList([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }

    const GetB2BTRFRegistrationDetailByTRFId = (trfId) => {
        //debugger;
        // setLoading(true);
        setSearchLoading(true);
        TRFListRegistrationService.GetB2BTRFRegistrationDetailByTRFId(trfId)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    //console.log(data.Data);
                    setB2BTRFRegistrationDetails(data.Data);
                    setShowPreview(true);
                }
                else {
                    setB2BTRFRegistrationDetails([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }

    const RepushFailedRegistration = (trfId) => {
        //debugger;
        // setLoading(true);
        setSearchLoading(true);
        TRFListRegistrationService.RepushFailedRegistration(trfId)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    fetchB2BTRFRegistrationListData();
                    // setShowPreview(true);
                    toast.success(data.ResponseMessage)
                }
                else {
                    // setB2BTRFRegistrationDetails([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }


    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(15); // Set number of items per page

    // Pagination logic
    const indexOfLastTRF = currentPage * itemsPerPage;
    const indexOfFirstTRF = indexOfLastTRF - itemsPerPage;
    const currentfilteredB2BTRFRegistrationtList = filteredB2BTRFRegistrationtList.slice(indexOfFirstTRF, indexOfLastTRF);

    const handleAttachmentDownload = (url) => {
        if (!url) {
            toast.error("No file URL provided.");
            return;
        }
        B2BRegistrationService.View_UploadedFile(url)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //debugger;
                    // window.open(data.Data, '_blank');
                    const newWindow = window.open(data.Data, "_blank");
                    if (newWindow) {
                        newWindow.focus();
                        newWindow.print();
                    }
                } else {
                    toast.error("Failed to download file.");
                }
            })
            .catch(() => toast.error("Something went wrong while downloading."));
    };

    const handleDateRangeChange = (e) => {
        const selected = e.target.value;
        setDateRangeOption(selected);

        const today = new Date();
        let start = null;
        let end = null;

        const startOfDay = (date) => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            return d;
        };

        const endOfDay = (date) => {
            const d = new Date(date);
            d.setHours(23, 59, 59, 999);
            return d;
        };

        switch (selected) {
            case 'Today':
                start = startOfDay(today);
                end = endOfDay(today);
                break;
            case 'Yesterday':
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                start = startOfDay(yesterday);
                end = endOfDay(yesterday);
                break;
            case 'Current Week':
                const dayOfWeek = today.getDay(); // 0 = Sunday
                start = startOfDay(new Date(today));
                start.setDate(today.getDate() - dayOfWeek);
                end = endOfDay(today);
                break;
            case 'Last 7 Days':
                start = startOfDay(new Date(today));
                start.setDate(today.getDate() - 6); // includes today
                end = endOfDay(today);
                break;
            case 'MTD':
                start = startOfDay(new Date(today.getFullYear(), today.getMonth(), 1));
                end = endOfDay(today);
                break;
            case 'Last 30 Days':
                start = startOfDay(new Date(today));
                start.setDate(today.getDate() - 29); // last 30 days including today
                end = endOfDay(today);
                break;
            case 'Custom':
                start = startDate;
                end = endDate;
                break;
            default:
                break;
        }

        setStartDate(start);
        setEndDate(end);
    };


    const calculateAge = (dob) => {
        if (!dob) return "-";

        const birthDate = new Date(dob);
        const today = new Date();

        let years = today.getFullYear() - birthDate.getFullYear();
        let months = today.getMonth() - birthDate.getMonth();
        let days = today.getDate() - birthDate.getDate();

        // Adjust if negative
        if (days < 0) {
            months--;
            const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
            days += prevMonth;
        }
        if (months < 0) {
            years--;
            months += 12;
        }

        // Convert everything into total days for flexibility
        const diffTime = today - birthDate;
        const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const totalMonths = years * 12 + months;

        // Logic
        if (years >= 2) {
            return `${years} Year${years > 1 ? "s" : ""}`;
        } else if (years >= 1) {
            // show year with decimal (e.g. 1.6 Year)
            const decimalYear = (totalMonths / 12).toFixed(1);
            return `${decimalYear} Year`;
        } else if (totalMonths >= 1) {
            return `${totalMonths} Month${totalMonths > 1 ? "s" : ""}`;
        } else if (totalDays >= 7) {
            const weeks = Math.floor(totalDays / 7);
            const remDays = totalDays % 7;
            return `${weeks} Week${weeks > 1 ? "s" : ""}${remDays > 0 ? ` ${remDays} Day${remDays > 1 ? "s" : ""}` : ""}`;
        } else {
            return `${totalDays} Day${totalDays > 1 ? "s" : ""}`;
        }
    };

    const handleRegistration = () => {
        if (accountDetails.MHL_Status__c !== "Active") {
            Swal.fire({
                icon: "warning",
                title: "Action Not Allowed",
                text: "You don’t have permission to perform registration. Please contact MHL Admin for assistance.",
                confirmButtonText: "OK",
            });
            return;
        }

        navigate("/registration");
    };



    const [selectedTRFPDFArrayList, setSelectedTRFPDFArrayList] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
        const availableRecords = filteredB2BTRFRegistrationtList.filter(
            rec => rec.TRF_Status === "Processed"
        );

        if (selectAll) {
            setSelectedTRFPDFArrayList([]);
        } else {
            const selected = availableRecords.map(rec => ({
                Reg_Trf_Id: rec.Reg_Trf_Id
            }));
            setSelectedTRFPDFArrayList(selected);
        }

        setSelectAll(!selectAll);
    };


    const handleCheckboxChange = (rec) => {
        const exists = selectedTRFPDFArrayList.some(
            r => r.Reg_Trf_Id === rec.Reg_Trf_Id
        );

        if (exists) {
            const updated = selectedTRFPDFArrayList.filter(
                r => r.Reg_Trf_Id !== rec.Reg_Trf_Id
            );
            setSelectedTRFPDFArrayList(updated);
            setSelectAll(false);
        } else {
            const updated = [
                ...selectedTRFPDFArrayList,
                { Reg_Trf_Id: rec.Reg_Trf_Id }
            ];
            setSelectedTRFPDFArrayList(updated);

            const availableRecords = filteredB2BTRFRegistrationtList.filter(
                r => r.TRF_Status === "Processed"
            );

            if (updated.length === availableRecords.length) {
                setSelectAll(true);
            }
        }
    };

    const isChecked = (Reg_Trf_Id) =>
        selectedTRFPDFArrayList.some(r => r.Reg_Trf_Id === Reg_Trf_Id);


    const GetTRFRegistrationPDFList = () => {
        //debugger;

        if (!selectedTRFPDFArrayList || selectedTRFPDFArrayList.length === 0) {
            toast.error("Please select at least one TRF");
            return;
        }

        const trfIds = selectedTRFPDFArrayList
            .map(x => x.Reg_Trf_Id)
            .join(",");

        if (!trfIds) {
            toast.error("Invalid TRF selection");
            return;
        }


        setSearchLoading(true);
        setLoading(true);

        B2BRegistrationService.GetTRFRegistrationPDFListURL(trfIds, orgId?.MHL_Organization_Name)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    if (data.Data) {
                        window.open(data.Data, "_blank");
                    } else {
                        toast.error("PDF URL not found");
                    }
                } else {
                    toast.error(data.ResponseMessage || "Failed to generate PDF");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {setSearchLoading(false); setLoading(false);});
    };

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 m-0 p-0">
            <Toaster position="top-center" reverseOrder={false} />
            <div className="card w-100 shadow-lg border-0 m-0 p-0" style={{ minHeight: "125vh" }}>
                <div className="card-body m-0">

                    {/* Header section */}
                    <div className="registration-list-header-section mb-3 gap-3">

                        {/* Heading and subheading inline */}
                        <div className="d-flex align-items-center flex-wrap gap-2">
                            <div className="mb-1"><FaClipboardList size={20} /></div>
                            <h4 className="m-0">Registrations</h4>
                        </div>

                        {/* Add button */}
                        <div className="d-flex align-items-center gap-2">
                            <button className="btn custom-sumbitbtn d-flex align-items-center common-container-btn registration-btn" onClick={handleRegistration}>
                                <FaPlus className="me-2" />
                                Registration
                            </button>
                        </div>

                    </div>

                    {/* Body content */}
                    <div>

                        <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">

                            <div className="d-flex flex-column flex-lg-row gap-2 justify-content-between mb-2">

                                <div className="d-flex flex-column flex-md-row gap-1 align-items-md-center">

                                    <select
                                        className="form-select patient-visit-form-select mb-2 mb-md-0 custom-select-dropdown"
                                        style={{ maxWidth: "200px" }}
                                        value={dateRangeOption}
                                        onChange={handleDateRangeChange}
                                    >
                                        <option value="Today">Today</option>
                                        <option value="Yesterday">Yesterday</option>
                                        <option value="Current Week">Current Week</option>
                                        <option value="Last 7 Days">Last 7 Days</option>
                                        <option value="MTD">MTD</option>
                                        <option value="Last 30 Days">Last 30 Days</option>
                                        <option value="Custom">Custom</option>
                                    </select>


                                    {(dateRangeOption === "Custom") && (
                                        <>
                                            <div className="position-relative mb-2 mb-md-0">
                                                <ReactDatePicker
                                                    selected={startDate}
                                                    onChange={(date) => setStartDate(date)}
                                                    className="form-control"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select Start Date"
                                                    ref={startDateRef}
                                                />
                                                <Calendar
                                                    size={20}
                                                    className="position-absolute "
                                                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                    onClick={() => startDateRef.current.setFocus()}
                                                />
                                            </div>

                                            <div className="position-relative mb-2 mb-md-0">
                                                <ReactDatePicker
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                    className="form-control mobile-style"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select End Date"
                                                    ref={endDateRef}
                                                />
                                                <Calendar
                                                    size={20} className="position-absolute"
                                                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                    onClick={() => endDateRef.current.setFocus()}
                                                />
                                            </div>

                                        </>
                                    )}

                                    <div className="d-flex me-1 align-items-center">
                                        <button
                                            className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-btn"
                                            // style={{ height: "35px", padding: "0" }}
                                            onClick={fetchB2BTRFRegistrationListData}
                                            disabled={SearchLoading}
                                        >
                                            {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
                                        </button>
                                    </div>

                                    <button
                                        className="btn custom-sumbitbtn ms-2"
                                        onClick={GetTRFRegistrationPDFList}
                                        disabled={SearchLoading}
                                    >
                                        {SearchLoading ? <><FaSpinner className="fa-spin" /> Download TRFs List</>: <b>   Download TRFs List</b>}

                                    </button>

                                    {/* <div className="my-2">
                            {SearchLoading ?
                                <CommonVariables.LoadingMessage />
                                : null}
                        </div> */}
                                </div>

                            </div>

                            <div className="d-none flex-column flex-md-row gap-2 mb-2">

                                <div>

                                    <div className="d-flex flex-column flex-md-row gap-2" style={{ whiteSpace: "nowrap" }}>
                                        <div className="position-relative d-flex justify-content-between align-items-center ">
                                            <label className="mb-0 mr-2">Start Date:</label>
                                            <ReactDatePicker
                                                selected={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Select Start Date"
                                                ref={startDateRef}
                                            />
                                            <Calendar
                                                size={20}
                                                className="position-absolute"
                                                style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                onClick={() => startDateRef.current.setFocus()}
                                            />
                                        </div>

                                        <div className="position-relative d-flex justify-content-between align-items-center ">
                                            <label className="mb-0 mr-2">End Date:</label>
                                            <ReactDatePicker
                                                selected={endDate}
                                                onChange={(date) => setEndDate(date)}
                                                className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Select End Date"
                                                ref={endDateRef}
                                            />
                                            <Calendar
                                                size={20} className="position-absolute"
                                                style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                onClick={() => endDateRef.current.setFocus()}
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div>
                                    <button
                                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-btn"
                                        style={{ height: "35px", padding: "0" }}
                                        onClick={fetchB2BTRFRegistrationListData}
                                        disabled={loading}
                                    >
                                        {/* <FaSearch /> */}
                                        {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
                                    </button>
                                </div>
                                {/* <button
                        className="btn btn-danger d-flex align-items-center justify-content-center refresh-btn"
                        style={{ height: "35px", padding: "0" }}
                        onClick={() => window.location.reload()}
                    >
                        <FaSyncAlt />
                    </button> */}
                                <div>
                                    {SearchLoading ?
                                        <CommonVariables.LoadingMessage />
                                        : null}
                                </div>
                            </div>

                            <div className="search-box trf-registration-list-search-box" style={{ position: "relative", width: "320px" }}>
                                <div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by Name, PID, VID, TRF ID"
                                        ref={selectedSearchPR}
                                        style={{
                                            paddingRight: "35px",
                                            borderRadius: "5px",
                                            border: "1px solid #ddd",
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                fetchUniversalFilterTRFListData();
                                            }
                                        }}
                                    />
                                    <button
                                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
                                        style={{
                                            padding: '5px',
                                            position: "absolute",
                                            top: "0",
                                            right: "0px",
                                            height: "35px",
                                            width: "45px",
                                            // top: "49% !important",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            // transform: "translateY(-60%)"
                                        }}
                                        onClick={fetchUniversalFilterTRFListData}

                                        disabled={SearchLoading}
                                    >
                                        <FaSearch />
                                        {/* <span className="ms-2 d-md-none">Search</span> */}
                                    </button>
                                </div>
                            </div>

                            {/* <div className="search-box" style={{ position: "relative", }}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        ref={selectedSearch}
                        style={{
                            paddingRight: "35px",
                            borderRadius: "5px",
                            border: "1px solid #ddd",
                        }}
                    />
                    <button
                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
                        style={{
                            padding: '5px',
                            position: "absolute",
                            right: "0px",
                            height: "35px",
                            width: "45px",
                            top: "50%",
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                            transform: "translateY(-50%)"
                        }}
                        onClick={fetchUniversalTRFRegistrationData}
                        disabled={loading}
                    >
                        <FaSearch />
                    </button>

                </div> */}
                        </div>

                        {/* <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "650px" }}> */}
                        <div className="table-responsive">
                            <table className="table table-bordered custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "3%" }}>
                                            <input
                                                type="checkbox"
                                                onChange={handleSelectAll}
                                                checked={selectAll}
                                                title="Select All AVAILABLE"
                                            />
                                        </th>

                                        <th style={{ width: "22%" }}>TRF ID</th>
                                        <th style={{ width: "12%" }}>VID</th>
                                        <th>Patient Info</th>
                                        {/* <th>Patient Details</th> */}
                                        <th style={{ width: "12%" }}>Collection Date</th>

                                        <th style={{ width: "10%" }}>Location</th>
                                        <th style={{ width: "8%" }}>Status</th>
                                        <th style={{ width: "12%" }}>Created Date</th>
                                        <th style={{ width: "8%" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="trf-detail-list-small-font">
                                    {currentfilteredB2BTRFRegistrationtList.length > 0 ? (
                                        currentfilteredB2BTRFRegistrationtList.map((item) => (
                                            <tr key={item.Registration_Id}>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    {item.TRF_Status === "Processed" && (
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleCheckboxChange(item)}
                                                            checked={isChecked(item.Reg_Trf_Id)}
                                                            title="Select to include in Report List"
                                                        />
                                                    )}
                                                </td>
                                                <td className="text-center">{item.Reg_Trf_Id}
                                                    {/* <br /> <strong>VID</strong>: {item.Vid || "-"}  */}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {item.Vid ? (
                                                        <span
                                                            title="View VID Details"
                                                            style={{
                                                                color: '#007bff',
                                                                textDecoration: 'underline',
                                                                cursor: 'pointer',
                                                                fontSize: '13px',
                                                                transition: 'color 0.2s',
                                                            }}
                                                            onClick={() => GetPatientTestDetailTAT(item)}
                                                            onMouseEnter={e => (e.currentTarget.style.color = '#0056b3')}
                                                            onMouseLeave={e => (e.currentTarget.style.color = '#007bff')}
                                                        >
                                                            {item.Vid}
                                                        </span>
                                                    ) : (
                                                        <span style={{ color: 'gray', fontSize: '13px' }}>—</span>
                                                    )}
                                                </td>

                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    <Popover
                                                        content={
                                                            <div style={{ textAlign: "left" }}>
                                                                <p><strong>Patient Name:</strong> {`${item.First_Name || ""} ${item.Middle_Name || ""} ${item.Last_Name || ""}`.trim()}</p>
                                                                <p><strong>DOB:</strong> {item.Dob ? new Date(item.Dob).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</p>
                                                                <p><strong>PID:</strong> {item.Pid || "-"}</p>
                                                                <p><strong>Mobile:</strong> {item.Mobile_Number || "Not Provided"}</p>
                                                                <p><strong>Gender:</strong> {item.Gender || "-"}</p>
                                                            </div>
                                                        }
                                                    >
                                                        <FaUser color="green" size={13} className="mb-1" /> &nbsp;
                                                    </Popover>

                                                    {/* Display only first 30 characters of the first name */}
                                                    <strong>
                                                        {(item.First_Name || "").length > 25
                                                            ? `${item.First_Name.substring(0, 25)}...`
                                                            : item.First_Name || ""}
                                                    </strong>
                                                    <br />

                                                    {item.Gender}
                                                    {item.Dob && (
                                                        <> | {format(parseISO(item.Dob), "dd-MMM-yyyy")} </>
                                                    )}
                                                </td>

                                                {/* <td>
                                        {`${item.First_Name || ""} ${item.Middle_Name || ""} ${item.Last_Name || ""}`.trim()}
                                    </td> */}
                                                <td className="text-center">
                                                    {new Date(item.Sample_Collection_Datetime).toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}
                                                    {/* <br />
                                                    <b>Created:</b>&nbsp; */}
                                                </td>

                                                <td>{item.Org_Location_Name}</td>
                                                <td>
                                                    {item.TRF_Status === "Failed" && (

                                                        <Popover
                                                            content={
                                                                <div style={{ textAlign: "left" }}>
                                                                    {/* <div><strong>Sr. No:</strong> {index + 1}</div> */}

                                                                    {!item?.TRF_Detail_Status?.Is_Trf_Generated && (
                                                                        <div>{item.TRF_Detail_Status?.Trf_Error_Message}</div>
                                                                    )}

                                                                    {!item?.TRF_Detail_Status?.Is_Registration && (
                                                                        <div>{item.TRF_Detail_Status?.Rni_Error_Message}</div>
                                                                    )}
                                                                </div>
                                                            }
                                                        >
                                                            {/* Icon triggers popover */}
                                                            <FaInfoCircle
                                                                color="green"
                                                                size={13}
                                                                className="mb-1"
                                                                style={{ cursor: "pointer" }}
                                                            />{" "}
                                                            &nbsp;
                                                        </Popover>
                                                    )}
                                                    {item.TRF_Status}
                                                </td>

                                                <td>
                                                    {new Date(item.Created_On).toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}

                                                </td>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    <div className="d-flex align-items-center gap-2 pl-2">
                                                        <div className="d-flex gap-2 align-items-center px-2">
                                                            {/* {item.Trf_Path ? (
                                                                <span
                                                                    disabled={loading}
                                                                    className="d-flex"
                                                                    title="View TRF PDF"
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        transition: 'transform 0.2s',
                                                                        cursor: 'pointer',
                                                                        fontSize: '12px'
                                                                    }}
                                                                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                >
                                                                    <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} />
                                                                </span>
                                                                // <i onClick={() => handleAttachmentDownload(item.Trf_Path)} role="button" style={{ color: "green", cursor: "pointer" }} className="fas fa-file-alt" >
                                                                // </i>
                                                            ) : (
                                                                "-"
                                                            )}
                                                             */}

                                                            {userDetails?.Is_Show_TRF_BaseURL ? (
                                                                item.TRFBaseURL ? (
                                                                    <span className="d-flex">
                                                                        <FaFileAlt color="green" size={16} onClick={() => window.open(item.TRFBaseURL, '_blank')} style={{ cursor: 'pointer' }} />
                                                                    </span>
                                                                ) : item.Trf_Path ? (
                                                                    <span
                                                                        disabled={loading}
                                                                        className="d-flex"
                                                                        title="View TRF PDF"
                                                                        style={{ display: 'inline-block', transition: 'transform 0.2s', cursor: 'pointer', fontSize: '12px' }}
                                                                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                    >
                                                                        <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} style={{ cursor: 'pointer' }} />
                                                                    </span>
                                                                ) : "-"
                                                            ) : item.Trf_Path ? (
                                                                <span
                                                                    disabled={loading}
                                                                    className="d-flex"
                                                                    title="View TRF PDF"
                                                                    style={{ display: 'inline-block', transition: 'transform 0.2s', cursor: 'pointer', fontSize: '12px' }}
                                                                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                >
                                                                    <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} style={{ cursor: 'pointer' }} />
                                                                </span>
                                                            ) : "-"}

                                                            <span
                                                                disabled={loading}
                                                                className="d-flex"
                                                                title="View TRF Details"
                                                                style={{
                                                                    display: 'inline-block',
                                                                    transition: 'transform 0.2s',
                                                                    cursor: 'pointer',
                                                                    fontSize: '12px'
                                                                }}
                                                                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                onClick={() => { GetB2BTRFRegistrationDetailByTRFId(item.Reg_Trf_Id) }}

                                                            >
                                                                <Eye color="green" />
                                                            </span>

                                                            {item.TRF_Status === "Failed" && (
                                                                <span
                                                                    title="ReTry Registration"
                                                                    style={{
                                                                        display: "inline-block",
                                                                        transition: "transform 0.2s",
                                                                        cursor: "pointer",
                                                                        fontSize: "15px",
                                                                    }}
                                                                    onMouseEnter={(e) =>
                                                                        (e.currentTarget.style.transform = "scale(1.2)")
                                                                    }
                                                                    onMouseLeave={(e) =>
                                                                        (e.currentTarget.style.transform = "scale(1)")
                                                                    }
                                                                >
                                                                    <FaPaperPlane
                                                                        disabled={SearchLoading}
                                                                        className="d-flex"
                                                                        style={{ color: "green" }}
                                                                        onClick={() => RepushFailedRegistration(item.Reg_Trf_Id)}
                                                                    />
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No Registrations Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>




                        </div>

                        {showPatientTestTATModal && (
                            <PatientTestDetailsModalComponent
                                visit={visit}
                                handlePatientTestTATClose={() => setshowPatientTestTATModal(false)}
                                patient={patient}
                                samples={samples}
                                reportURL={reportURL}
                                handleReportDownload={handleReportDownload}
                                reportWOSURL={reportWOSURL}
                                visitStatus={visitStatus}
                                tests={tests}
                                crmVisitDetails={crmVisitDetails}
                            />
                        )}

                        {showPreview && b2bTRFRegistrationDetails && (
                            <>
                                <div className="modal-backdrop" > </div>
                                <div className="modal fade show d-block success" tabIndex="-1"
                                // style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                                >
                                    <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header custom-card-heading text-white p-2">
                                                <h5 className="modal-title text-white px-2">Patient TRF Details ({b2bTRFRegistrationDetails.Reg_Trf_Id})</h5>
                                                <button type="button" className="btn-close btn-close-white mr-1" onClick={() => setShowPreview(false)}></button>
                                            </div>
                                            <div className="modal-body">

                                                {/* Patient Details */}
                                                <h6 className="mb-2"><strong>Patient Details</strong></h6>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ borderRight: '1px solid #ccc' }}>
                                                        <p><strong>Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Salutation} {b2bTRFRegistrationDetails.Patient_Details?.First_Name} {b2bTRFRegistrationDetails.Patient_Details?.Middle_Name} {b2bTRFRegistrationDetails.Patient_Details?.Last_Name}</p>
                                                        <p><strong>Gender:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Gender}</p>
                                                        <p><strong>DOB:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Dob ? new Date(b2bTRFRegistrationDetails.Patient_Details.Dob).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</p>
                                                        <p>
                                                            <strong>Patient History:</strong>{" "}
                                                            {b2bTRFRegistrationDetails.Patient_History ? (() => {
                                                                const historyItems = b2bTRFRegistrationDetails.Patient_History
                                                                    .split(",")
                                                                    .map(x => x.trim())
                                                                    .filter(x => x);
                                                                if (historyItems.length === 0)
                                                                    return <span className="text-muted">No history</span>;
                                                                if (historyItems.length === 1)
                                                                    return <span>{historyItems[0]}</span>;
                                                                return (
                                                                    <Popover
                                                                        content={
                                                                            <ul className="list-unstyled m-0 p-1">
                                                                                {historyItems.map((item, i) => (
                                                                                    <li key={i}>{item}</li>
                                                                                ))}
                                                                            </ul>
                                                                        }
                                                                    >
                                                                        <span style={{ cursor: "pointer" }}>
                                                                            {historyItems[0]} +{historyItems.length - 1}
                                                                        </span>
                                                                    </Popover>
                                                                );
                                                            })() : (
                                                                <span className="text-muted">Not Provided</span>
                                                            )}
                                                        </p>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><strong>Mobile:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Mobile_Number || <span className="text-muted">Not Provided</span>}</p>
                                                        {/* <p><strong>Email:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Email || <span className="text-muted">Not Provided</span>}</p> */}
                                                        {/* <p><strong>Dr. Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Doctor_Name || <span className="text-muted">Not Provided</span>}</p> */}
                                                        <p>
                                                            <strong>Remarks:</strong>{" "}
                                                            {b2bTRFRegistrationDetails.Remarks ? (
                                                                b2bTRFRegistrationDetails.Remarks.length > 40 ? (
                                                                    <Popover
                                                                        content={
                                                                            <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
                                                                                {b2bTRFRegistrationDetails.Remarks}
                                                                            </div>
                                                                        }
                                                                    >
                                                                        <span style={{ cursor: "pointer", textDecoration: "underline" }}>
                                                                            {b2bTRFRegistrationDetails.Remarks.slice(0, 40)}...
                                                                        </span>
                                                                    </Popover>
                                                                ) : (
                                                                    b2bTRFRegistrationDetails.Remarks
                                                                )
                                                            ) : (
                                                                <span className="text-muted">Not Provided</span>
                                                            )}
                                                        </p>
                                                          <p><strong>Ref. Dr Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Doctor_Name || <span className="text-muted">Not Provided</span>}</p>
                                                          <p><strong>Ref. ID:</strong> {b2bTRFRegistrationDetails.Patient_Details?.External_Order_Id || <span className="text-muted">Not Provided</span>}</p>
                                                    </div>
                                                </div>


                                                {/* Patient Attachments */}
                                                <div className="row mt-2">
                                                    <div className="col-md-12 d-flex align-items-center">
                                                        <strong>Patient Attachments:</strong>&nbsp;
                                                        {b2bTRFRegistrationDetails.Patient_Attachments &&
                                                            b2bTRFRegistrationDetails.Patient_Attachments.length > 0 ? (
                                                            <a
                                                                href="#"
                                                                onClick={(e) => { e.preventDefault(); setShowAttachments(true); }}
                                                                className="text-primary"
                                                                style={{ textDecoration: "underline", cursor: "pointer" }}
                                                            >
                                                                View Uploaded Attachments ({b2bTRFRegistrationDetails.Patient_Attachments.length})
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted">No patient attachments uploaded.</span>
                                                        )}
                                                    </div>

                                                </div>


                                                {/* Test Details */}
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <h6><strong>Lab Investigations</strong> ({b2bTRFRegistrationDetails.Patient_Tests?.length || 0})</h6>
                                                    <span><strong>Sample Date/Time: </strong>
                                                        {b2bTRFRegistrationDetails.Sample_Collection_Datetime &&
                                                            new Date(b2bTRFRegistrationDetails.Sample_Collection_Datetime).toLocaleString("en-GB", {
                                                                day: "2-digit", month: "short", year: "numeric",
                                                                hour: "2-digit", minute: "2-digit", hour12: true
                                                            }).replace(",", "").replace(/\s?(am|pm)/i, (m) => m.toUpperCase())}
                                                    </span>
                                                </div>

                                                <div style={{ maxHeight: "150px", overflowY: "auto" }} className="table-responsive-trf-summary mb-2">
                                                    <table className="table table-bordered custom-table mb-1">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th style={{ width: "35%" }}>Test Name (Code)</th>
                                                                {/* <th>Code</th> */}
                                                                <th>Test TAT</th>
                                                                <th style={{ width: "20%" }}>Test Remarks</th>
                                                                {/* <th>Type</th> */}
                                                                <th>Processing Location</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="trf-detail-list-small-font">
                                                            {b2bTRFRegistrationDetails.Patient_Tests?.length > 0 ? (
                                                                b2bTRFRegistrationDetails.Patient_Tests.map((test, idx) => (
                                                                    <tr key={idx}>
                                                                        <td className="text-left align-middle" style={{ width: '35%', whiteSpace: 'normal', wordBreak: 'break-word' }}>{test.Test_Name} (<b>{test.Test_Code}</b>)</td>
                                                                        <td>{CommonVariables.formatUTCToIST(test.Test_Tat)}</td>
                                                                        <td>
                                                                            {test.Remarks
                                                                                ? test.Remarks.length > 20 ? (
                                                                                    <Popover
                                                                                        content={
                                                                                            <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
                                                                                                {test.Remarks}
                                                                                            </div>
                                                                                        }
                                                                                    >
                                                                                        <span style={{ cursor: "pointer" }}>
                                                                                            {test.Remarks.slice(0, 20)}...
                                                                                        </span>
                                                                                    </Popover>
                                                                                ) : (
                                                                                    test.Remarks
                                                                                )
                                                                                : (
                                                                                    "-"
                                                                                )}

                                                                        </td>
                                                                        <td> {test.Processing_Location && (
                                                                            <>
                                                                                {test.Processing_Location.includes(",") ? (
                                                                                    <Popover
                                                                                        content={
                                                                                            <ul
                                                                                                className="list-unstyled"
                                                                                                style={{ textAlign: "left", paddingLeft: "2px", margin: 0 }}
                                                                                            >
                                                                                                {test.Processing_Location.split(",").map((loc, index) => (
                                                                                                    <li key={index}>{loc.trim()}</li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        }
                                                                                    >
                                                                                        <span style={{ cursor: "pointer" }}>
                                                                                            {test.Processing_Location.split(",")[0]}{" "}
                                                                                            (+{test.Processing_Location.split(",").length - 1})
                                                                                        </span>
                                                                                    </Popover>
                                                                                ) : (
                                                                                    test.Processing_Location
                                                                                )}
                                                                            </>
                                                                        )}</td>
                                                                        <td className="text-center">
                                                                            {test.Is_Required_History ? (
                                                                                <div
                                                                                    title="View Document"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        setSelectedTest(test);
                                                                                        setShowHistoryModal(true);
                                                                                    }}

                                                                                >
                                                                                    <FaEye color="green" size={19} />
                                                                                </div>
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </td>


                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr><td colSpan="4" className="text-center">No tests found</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Patient Test Samples */}
                                                <h6 className="mt-3 mb-2"><strong>Investigations Container & Samples</strong> ({b2bTRFRegistrationDetails.Patient_Test_Samples?.length || 0})</h6>
                                                <div style={{ maxHeight: "150px", overflowY: "auto" }} className="table-responsive-trf-summary mb-2">
                                                    <table className="table table-bordered custom-table">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>Container Name</th>
                                                                <th>Sample Name</th>
                                                                {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                                                    <th>Barcode</th>
                                                                )}
                                                                <th>Processing Location</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="trf-detail-list-small-font">
                                                            {b2bTRFRegistrationDetails.Patient_Test_Samples &&
                                                                b2bTRFRegistrationDetails.Patient_Test_Samples.length > 0 ? (
                                                                b2bTRFRegistrationDetails.Patient_Test_Samples.map((sample, i) => (
                                                                    <tr key={i}>
                                                                        <td>{sample.Container_Name}</td>
                                                                        <td>{sample.Sample_Name}</td>
                                                                        {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                                                            <td>{sample.Barcode_Id}</td>)}
                                                                        <td>{sample.Processing_Location}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr><td colSpan="5" className="text-center">No samples found</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="modal-footer p-2">
                                                {/* <button type="button" className="btn btn-danger" onClick={() => setShowPreview(false)}>Close</button> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}


                        {showAttachments && (
                            <div className="modal-backdrop w-100">
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-l" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header p-2 ml-1">
                                                <h5 className="modal-title">Patient Attachement</h5>
                                                <button type="button" className="btn-close mr-1" onClick={() => setShowAttachments(false)}></button>
                                            </div>
                                            <div className="modal-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                                                {/* <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="table-responsive-trf-summary mb-1">
                                                    <table className="table table-bordered custom-table mb-1">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>#</th>
                                                                <th>File Type</th>
                                                                <th>URN Of</th>
                                                                <th>URN Number</th>
                                                                <th>File</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {b2bTRFRegistrationDetails.Patient_Attachments.map((att, i) => (
                                                                <tr key={i}>
                                                                    <td>{i + 1}</td>
                                                                    <td>{att.Urn_File_Type}</td>
                                                                    <td>{att.Urn_Of}</td>
                                                                    <td>{att.Urn_Number}</td>
                                                                    <td>
                                                                        <a href={att.Urn_File_Path} target="_blank" rel="noopener noreferrer">View / Download</a>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div> */}

                                                <ul className="list-group small">
                                                    {b2bTRFRegistrationDetails.Patient_Attachments.map((att, idx) => (
                                                        <li className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center" key={idx}>
                                                            <span className="px-2" style={{ whiteSpace: "nowrap" }}>
                                                                {att.Urn_Of && <b>{att.Urn_Of.charAt(0)}</b>}
                                                                {att.Urn_Of ? " - " : ""}
                                                                {att.Urn_File_Type}
                                                                {att.Urn_Number ? ` (${att.Urn_Number})` : ""}
                                                            </span>
                                                            {/* <span className="px-2" style={{ whiteSpace: "nowrap" }}><b>{att.Urn_Of?.charAt(0)}</b> - {att.Urn_File_Type} ({att.Urn_Number})</span>        */}
                                                            <div className="d-flex align-items-center">

                                                                <div title="View Document" style={{ cursor: "pointer" }} onClick={() => handleAttachmentDownload(att.Urn_File_Path)} className="view-doc-btn-wrapper">
                                                                    <FaEye color="green" size={19} />
                                                                </div>

                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showHistoryModal && selectedTest && (
                            <>
                                <div className="modal-backdrop"></div>
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-l" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header p-2 ml-1">
                                                <h5 className="modal-title">
                                                    History - {selectedTest.Test_Name} ({selectedTest.Test_Code})
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white"
                                                    onClick={() => {
                                                        setShowHistoryModal(false);
                                                        setSelectedTest(null);
                                                    }}
                                                ></button>
                                            </div>

                                            <div className="modal-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                                                {selectedTest.History_Attributes?.length > 0 ? (
                                                    <div className="row g-2">
                                                        {selectedTest.History_Attributes.map((att, idx) => (
                                                            <div key={idx} className="col-12">
                                                                <div className="card shadow-sm border rounded p-2">
                                                                    <div className="d-flex flex-column">

                                                                        {/* Name */}
                                                                        <div className="d-flex align-items-center mb-1">
                                                                            <span className="fw-bold me-1">Name:</span>
                                                                            <span>{att.History_Name}</span>
                                                                        </div>

                                                                        {/* VALUE FOR NON-ATTACHMENTS */}
                                                                        {att.History_Attribute !== "Attachement" ? (
                                                                            <div className="d-flex align-items-center">
                                                                                <span className="fw-bold me-1">Value:</span>
                                                                                <span className="text-muted">{att.History_Value || "—"}</span>
                                                                            </div>
                                                                        ) : (
                                                                            /* ATTACHMENTS LIST WITH FILETYPE GROUPING */
                                                                            <>
                                                                                {(() => {
                                                                                    const typeCounters = {}; // Counter holder

                                                                                    return (
                                                                                        <ul className="list-group small mt-1">
                                                                                            {att.HistoryAttachments?.length > 0 ? (
                                                                                                att.HistoryAttachments.map((attachment, aidx) => {

                                                                                                    // increase counter for current fileType
                                                                                                    if (!typeCounters[attachment.fileType]) {
                                                                                                        typeCounters[attachment.fileType] = 1;
                                                                                                    } else {
                                                                                                        typeCounters[attachment.fileType]++;
                                                                                                    }

                                                                                                    const displayIndex = typeCounters[attachment.fileType];

                                                                                                    return (
                                                                                                        <li
                                                                                                            key={aidx}
                                                                                                            className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center"
                                                                                                        >
                                                                                                            <span className="px-2" style={{ whiteSpace: "nowrap" }}>
                                                                                                                <b>{attachment.fileType?.charAt(0)}</b> - {attachment.fileType} | Attachment {displayIndex}
                                                                                                            </span>

                                                                                                            <div className="d-flex align-items-center gap-2">
                                                                                                                <div
                                                                                                                    title="View Document"
                                                                                                                    style={{ cursor: "pointer" }}
                                                                                                                    onClick={() => handleAttachmentDownload(attachment.filePath)}
                                                                                                                    className="view-doc-btn-wrapper"
                                                                                                                >
                                                                                                                    <FaEye color="green" size={18} />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </li>
                                                                                                    );
                                                                                                })
                                                                                            ) : (
                                                                                                <li className="list-group-item text-muted">No attachments available</li>
                                                                                            )}
                                                                                        </ul>
                                                                                    );
                                                                                })()}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-center text-muted mb-0">
                                                        No history data available for this test.
                                                    </p>
                                                )}
                                            </div>

                                            <div className="modal-footer p-2">
                                                <button
                                                    className="btn btn-danger"
                                                    onClick={() => {
                                                        setShowHistoryModal(false);
                                                        setSelectedTest(null);
                                                    }}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {filteredB2BTRFRegistrationtList.length > itemsPerPage ? (
                            <CommonPagination
                                pageList={filteredB2BTRFRegistrationtList}
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                setCurrentPage={setCurrentPage}
                            />
                        ) : null}
                    </div>
                </div>
            </div >
        </div >
    );
};

export default TRFRegistrationListComponent;
